import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { ICON_NAMES } from '../../../../../../constants'
import FilterPill from './FilterPill'

const useStyles = makeStyles(() => ({
  bar: {
    height: '50px',
    '&::before': {
      content: '""',
      width: '100%',
      borderBottom: '2px solid var(--color-neutral-300)',
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0
    }
  }
}))

function PlanFilterPills ({ pills, totalCount, currentFilter, onFilter, allItemsLabel }) {
  const classes = useStyles()
  return (
    <div
      className={`${classes.bar} flex flex-row flex-wrap items-center mb-3 relative`}
      style={{ gap: 'var(--dim-6)' }}
    >
      <FilterPill
        icon={ICON_NAMES.radioUnchecked}
        label={allItemsLabel}
        count={totalCount}
        active={!currentFilter}
        onClick={() => onFilter(null)}
      />
      {pills.map(pill => (
        <FilterPill
          key={pill.key}
          style={pill.style}
          label={pill.label}
          count={pill.count}
          active={currentFilter === pill.key}
          onClick={() => onFilter(pill.key)}
        />
      ))}
    </div>
  )
}

PlanFilterPills.propTypes = {
  pills: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
    style: PropTypes.shape({ color: PropTypes.string, icon: PropTypes.string })
  })).isRequired,
  totalCount: PropTypes.number.isRequired,
  currentFilter: PropTypes.string,
  onFilter: PropTypes.func.isRequired,
  allItemsLabel: PropTypes.string
}

PlanFilterPills.defaultProps = {
  allItemsLabel: 'All Statuses'
}

export default PlanFilterPills
